import { ChangeDetectionStrategy, Component, Input, Optional, Self } from '@angular/core';
import { NgControl } from '@angular/forms';
import { ValidationMessageService } from '@common/services/validation-message.service';
import { AbstractFormControlComponent } from './abstract-form-control.component';

@Component({
    selector: 'form-textarea',
    styleUrls: ['form-controls.component.scss'],
    template: `
        <div class="form-group" [ngClass]="{ 'has-value': !!value }">
            <app-control
                type="textarea"
                [isDisabled]="isDisabled"
                [label]="labelText"
                [placeholder]="placeholder"
                [maxLength]="maxLength"
                [ngClass]="{ 'is-invalid': isInvalid }"
                [isInvalid]="isInvalid"
                [formControlValidators]="getFormControlValidators"
                [contextual]="contextual"
                [collapsible]="collapsible"
                [(ngModel)]="value"
                (ngModelChange)="changeValue($event)"></app-control>
        </div>
    `,
    providers: [],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class TextareaComponent extends AbstractFormControlComponent {
    @Input() labelText: string;
    @Input() contextual: string = null;
    @Input() isDisabled: boolean;
    @Input() textboxType = 'string';
    /** Shows the field as one clipped line until focused or expanded; see `AppControlComponent`. */
    @Input() collapsible = false;
    @Input() placeholder: string;
    @Input() maxLength: number;

    constructor(@Self() @Optional() controlDir: NgControl, validationMessageService: ValidationMessageService) {
        super(controlDir, validationMessageService);
    }
}
